
import {
  AisInstantSearch,
  AisPagination,
  AisHits,
 
  AisConfigure,
} from 'vue-instantsearch'
import 'instantsearch.css/themes/satellite-min.css'
import algoliasearch from 'algoliasearch/lite'
import categoryData from '@/data/category.json'
import BlogCard from '@/components/Blog/Card.vue'
const algoliaClient = algoliasearch(
  '6CXFQTPZG1',
  'ee00dfb41ca6a3c3ebfb33a6876120b6'
)
const searchClient = {
  search(requests) {
    return algoliaClient.search(requests)
  },
  searchForFacetValues(requests) {
    return algoliaClient.searchForFacetValues(requests)
  }
}
export default {
   components: {
    BlogCard,
    AisInstantSearch,
    AisConfigure,
    // AisSearchBox,
    AisHits,
    AisPagination

  },
   layout:'blog',
  async asyncData({store,route, payload }) {
 let category,catObj;

    if (typeof route.params.category !== 'undefined') {
      category =  await route.params.category
      catObj=categoryData.find((i) => i.slug === category)

    }
    if (payload) return { posts: payload,catObj }
    else return {posts : await store.dispatch('posts/getPostbyCategory',{ slug: category}),catObj}

  },
   data() {
    return {
      searchClient,
 
      filters: [],
      array: [],
    }
  },
   
}
